// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/transfer/v1/account_files.proto (package kitecorp.transferify.transfer.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_kitecorp_options_v1_options } from "../../../options/v1/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/transfer/v1/account_files.proto.
 */
export const file_kitecorp_transferify_transfer_v1_account_files: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_kitecorp_options_v1_options]);

/**
 * Asks for one page of the caller's files.
 *
 * @generated from message kitecorp.transferify.transfer.v1.ListAccountFilesRequest
 */
export type ListAccountFilesRequest = Message<"kitecorp.transferify.transfer.v1.ListAccountFilesRequest"> & {
  /**
   * The order. Absent: SORT_NEWEST.
   *
   * @generated from field: optional kitecorp.transferify.transfer.v1.ListAccountFilesRequest.Sort sort = 1;
   */
  sort?: ListAccountFilesRequest_Sort | undefined;

  /**
   * How many rows the caller already holds, from zero. The next page starts after them.
   *
   * @generated from field: int32 offset = 2;
   */
  offset: number;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.ListAccountFilesRequest.
 * Use `create(ListAccountFilesRequestSchema)` to create a new message.
 */
export const ListAccountFilesRequestSchema: GenMessage<ListAccountFilesRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_account_files, 0);

/**
 * The orders the list can be read in. The account's files are ordered as a whole before a page is cut, and both
 * orders end on the file id, so no page repeats or skips a row.
 *
 * @generated from enum kitecorp.transferify.transfer.v1.ListAccountFilesRequest.Sort
 */
export enum ListAccountFilesRequest_Sort {
  /**
   * No order given.
   *
   * @generated from enum value: SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The newest file first.
   *
   * @generated from enum value: SORT_NEWEST = 1;
   */
  NEWEST = 1,

  /**
   * The largest file first, sized as the sender picked it. Files of one size come newest first.
   *
   * @generated from enum value: SORT_SIZE = 2;
   */
  SIZE = 2,
}

/**
 * Describes the enum kitecorp.transferify.transfer.v1.ListAccountFilesRequest.Sort.
 */
export const ListAccountFilesRequest_SortSchema: GenEnum<ListAccountFilesRequest_Sort> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_transfer_v1_account_files, 0, 0);

/**
 * One page of the caller's files.
 *
 * @generated from message kitecorp.transferify.transfer.v1.ListAccountFilesResponse
 */
export type ListAccountFilesResponse = Message<"kitecorp.transferify.transfer.v1.ListAccountFilesResponse"> & {
  /**
   * How many files the account holds, not only the page.
   *
   * @generated from field: int64 total_files = 1;
   */
  totalFiles: bigint;

  /**
   * Their size in bytes, as the sender picked them: an encrypted file counts without its framing.
   *
   * @generated from field: int64 total_bytes = 2;
   */
  totalBytes: bigint;

  /**
   * The most rows a page holds. A page holds fewer when its rows are large, so a shorter page does not end the list.
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;

  /**
   * The files of the page, in the requested order.
   *
   * @generated from field: repeated kitecorp.transferify.transfer.v1.AccountFile files = 4;
   */
  files: AccountFile[];
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.ListAccountFilesResponse.
 * Use `create(ListAccountFilesResponseSchema)` to create a new message.
 */
export const ListAccountFilesResponseSchema: GenMessage<ListAccountFilesResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_account_files, 1);

/**
 * One file of the account's file list. It carries no download link and no key.
 *
 * @generated from message kitecorp.transferify.transfer.v1.AccountFile
 */
export type AccountFile = Message<"kitecorp.transferify.transfer.v1.AccountFile"> & {
  /**
   * The file's id, a UUID.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The file's declared name. Absent for a legacy file recorded without one.
   *
   * @generated from field: optional string filename = 2;
   */
  filename?: string | undefined;

  /**
   * The file's size in bytes as the sender picked it: an encrypted file counts without its framing.
   *
   * @generated from field: int64 length = 3;
   */
  length: bigint;

  /**
   * The type the sender's browser declared. Absent when it declared none.
   *
   * @generated from field: optional string content_type = 4;
   */
  contentType?: string | undefined;

  /**
   * When the file was registered. Absent only for a file recorded without it.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;

  /**
   * The file's folder path including its name. Absent for a file at the root.
   *
   * @generated from field: optional string relative_path = 6;
   */
  relativePath?: string | undefined;

  /**
   * Whether the account sent the file or received it.
   *
   * @generated from field: kitecorp.transferify.transfer.v1.AccountFile.Direction direction = 7;
   */
  direction: AccountFile_Direction;

  /**
   * The id of the transfer that holds the file, a UUID.
   *
   * @generated from field: string transfer_id = 8;
   */
  transferId: string;

  /**
   * That transfer's title as its row shows it, the name of its first file. Absent when that file was recorded without
   * a name.
   *
   * @generated from field: optional string transfer_title = 9;
   */
  transferTitle?: string | undefined;

  /**
   * For a received file, the id of the file request it answered, a UUID. Absent for a sent file.
   *
   * @generated from field: optional string request_id = 10;
   */
  requestId?: string | undefined;

  /**
   * For a received file, that request's title. Absent for a sent file.
   *
   * @generated from field: optional string request_title = 11;
   */
  requestTitle?: string | undefined;

  /**
   * Whether the transfer's link still opens.
   *
   * @generated from field: kitecorp.transferify.transfer.v1.AccountFile.State state = 12;
   */
  state: AccountFile_State;

  /**
   * How the file is encrypted.
   *
   * @generated from field: kitecorp.transferify.transfer.v1.AccountFile.Encryption encryption = 13;
   */
  encryption: AccountFile_Encryption;

  /**
   * Whether the file belongs to an instant transfer, whose bytes are never stored.
   *
   * @generated from field: bool peer_to_peer = 14;
   */
  peerToPeer: boolean;

  /**
   * Whether abuse reports suspended the file's transfer. Its link then serves nobody, whatever state says.
   *
   * @generated from field: bool suspended = 15;
   */
  suspended: boolean;

  /**
   * The addresses the transfer was sent to.
   *
   * @generated from field: repeated string recipients = 16;
   */
  recipients: string[];

  /**
   * The current names of the contact groups the transfer was sent to, in alphabetical order whatever their case. A
   * deleted group is left out, and a received file names none.
   *
   * @generated from field: repeated string recipient_groups = 17;
   */
  recipientGroups: string[];

  /**
   * For a received file, the address its uploader signed in with. Absent for a sent file and for an upload recorded
   * before uploaders were.
   *
   * @generated from field: optional string uploader_email = 18;
   */
  uploaderEmail?: string | undefined;

  /**
   * For a received file, the uploader's name. Absent for a sent file, or when the uploader gave no name a recipient
   * may see.
   *
   * @generated from field: optional string uploader_name = 19;
   */
  uploaderName?: string | undefined;

  /**
   * When the file's stored bytes stop existing. Absent when nothing ever purges them, and for a peer-to-peer file,
   * which stores none.
   *
   * @generated from field: google.protobuf.Timestamp stored_until = 20;
   */
  storedUntil?: Timestamp | undefined;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.AccountFile.
 * Use `create(AccountFileSchema)` to create a new message.
 */
export const AccountFileSchema: GenMessage<AccountFile> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_account_files, 2);

/**
 * Which way the file travelled.
 *
 * @generated from enum kitecorp.transferify.transfer.v1.AccountFile.Direction
 */
export enum AccountFile_Direction {
  /**
   * No direction given.
   *
   * @generated from enum value: DIRECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A file of a transfer the account sent, including one it uploaded to another account's file request.
   *
   * @generated from enum value: DIRECTION_SENT = 1;
   */
  SENT = 1,

  /**
   * A file uploaded to one of the account's own file requests.
   *
   * @generated from enum value: DIRECTION_RECEIVED = 2;
   */
  RECEIVED = 2,
}

/**
 * Describes the enum kitecorp.transferify.transfer.v1.AccountFile.Direction.
 */
export const AccountFile_DirectionSchema: GenEnum<AccountFile_Direction> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_transfer_v1_account_files, 2, 0);

/**
 * Whether the link the file belongs to still opens.
 *
 * @generated from enum kitecorp.transferify.transfer.v1.AccountFile.State
 */
export enum AccountFile_State {
  /**
   * No state given.
   *
   * @generated from enum value: STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The link still opens.
   *
   * @generated from enum value: STATE_LIVE = 1;
   */
  LIVE = 1,

  /**
   * The link has expired, by the rule a recipient's download is refused on.
   *
   * @generated from enum value: STATE_EXPIRED = 2;
   */
  EXPIRED = 2,
}

/**
 * Describes the enum kitecorp.transferify.transfer.v1.AccountFile.State.
 */
export const AccountFile_StateSchema: GenEnum<AccountFile_State> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_transfer_v1_account_files, 2, 1);

/**
 * How the file is encrypted.
 *
 * @generated from enum kitecorp.transferify.transfer.v1.AccountFile.Encryption
 */
export enum AccountFile_Encryption {
  /**
   * No encryption given.
   *
   * @generated from enum value: ENCRYPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Encrypted in the browser, with its key wrapped by a key Transferify holds and stored beside it.
   *
   * @generated from enum value: ENCRYPTION_ESCROW = 1;
   */
  ESCROW = 1,

  /**
   * Encrypted, with its key only in the link's fragment: Transferify never has it.
   *
   * @generated from enum value: ENCRYPTION_ZERO_KNOWLEDGE = 2;
   */
  ZERO_KNOWLEDGE = 2,

  /**
   * Not encrypted by the browser: a file stored before every upload was encrypted, or a file of a peer-to-peer
   * transfer, whose bytes are never stored.
   *
   * @generated from enum value: ENCRYPTION_PLAINTEXT = 3;
   */
  PLAINTEXT = 3,
}

/**
 * Describes the enum kitecorp.transferify.transfer.v1.AccountFile.Encryption.
 */
export const AccountFile_EncryptionSchema: GenEnum<AccountFile_Encryption> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_transfer_v1_account_files, 2, 2);

/**
 * The files of the signed-in account, sent and received, for the Files tab (kitecorp/contracts#92). The account is
 * never named in a message.
 *
 * @generated from service kitecorp.transferify.transfer.v1.AccountFileService
 */
export const AccountFileService: GenService<{
  /**
   * Reads one page of every file the caller's account holds, ordered by sort. A page holds at most page_size rows and
   * fewer when its rows are large, so a page shorter than page_size does not end the list: the caller continues with
   * the number of rows it holds as the offset, and stops when it holds total_files. It changes nothing, so a client
   * may repeat it freely.
   *
   * @generated from rpc kitecorp.transferify.transfer.v1.AccountFileService.ListAccountFiles
   */
  listAccountFiles: {
    methodKind: "unary";
    input: typeof ListAccountFilesRequestSchema;
    output: typeof ListAccountFilesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kitecorp_transferify_transfer_v1_account_files, 0);

